var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReedemPointIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.081,
    height: 22.908,
    viewBox: "0 0 12.081 22.908",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2653",
    "data-name": "Group 2653",
    transform: "translate(-48 -193)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2471",
    "data-name": "Group 2471",
    transform: "translate(48 193)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2470",
    "data-name": "Group 2470"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5815",
    "data-name": "Path 5815",
    d: "M133.081,7.83V.671A.671.671,0,0,0,132.409,0H121.671A.671.671,0,0,0,121,.671V7.83a.671.671,0,0,0,.266.535l4.1,3.11a5.839,5.839,0,1,0,3.346,0l4.1-3.11A.671.671,0,0,0,133.081,7.83Zm-9.354.716L122.342,7.5V1.342h1.384Zm7.81,8.523a4.5,4.5,0,1,1-4.5-4.5A4.5,4.5,0,0,1,131.537,17.069Zm-2.525-7.505-1.972,1.5-1.972-1.5V1.342h3.943ZM131.738,7.5l-1.384,1.05v-7.2h1.384Z",
    transform: "translate(-121)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2472",
    "data-name": "Group 2472",
    transform: "translate(51 207.144)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5816",
    "data-name": "Path 5816",
    d: "M194.082,318.311a.671.671,0,0,0-.484-.446l-1.272-.3-.679-1.117a.671.671,0,0,0-1.147,0l-.679,1.117-1.272.3a.671.671,0,0,0-.355,1.091l.852.991-.107,1.3a.671.671,0,0,0,.928.674l1.206-.5,1.205.5a.671.671,0,0,0,.928-.674l-.107-1.3.852-.991A.671.671,0,0,0,194.082,318.311Zm-2.183.973a.671.671,0,0,0-.16.493l.04.482-.446-.187a.671.671,0,0,0-.518,0l-.446.187.04-.482a.671.671,0,0,0-.16-.493l-.315-.366.47-.111a.671.671,0,0,0,.419-.3l.251-.413.251.413a.671.671,0,0,0,.419.3l.47.111Z",
    transform: "translate(-188.033 -316.125)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReedemPointIcon);
export default __webpack_public_path__ + "static/media/reedem-point-icon.3dd1e418e0fc78d60f4d4e67695b587e.svg";
export { ForwardRef as ReactComponent };